export class ResumeRecord {
    public name: string = '';
    public fileGUID: string = '';
    public reference: string = '';
    public documentExtType: string = '';
    public defaultResume: boolean = false;
    public userId:number = -1;

}
